import { Property } from '@data/models';
import { apiCall } from '../axios';
export class PropertyService {
    static loadProperty({ code, language = 'en', bookingEngineSource, iframe, }) {
        const url = '/property_info';
        return apiCall(Property)('post', url, {
            booking_engine_source: bookingEngineSource,
            iframe,
            lang: language,
            property_code: code,
        }).then((property) => {
            return property;
        });
    }
}
